import * as Inovx from '@shared';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

var url = `${UrlUtilities.getApiUrl()}/EntitlementApi/api/entitlementgroup`;

var EntitlementServices: IEntitlementService = { ...Inovx.Shared.Flux.BaseService,
    getAll: function (successCallback: (retData: ISecurityGroup[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(url,
            null,
            (retData: ISecurityGroup[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },

    getApplicationPermissions: function (successCallback: (retData: IApplicationPermission[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/ApplicationPermissions`,
            null,
            (retData: IApplicationPermission[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },

    getDetail: function (id: string, successCallback: (retData: ISecurityGroupDetail) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/${id}`,
            {},
            (retData: ISecurityGroupDetail) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },

    create: function (entitlementGroup: ISecurityGroup, permissionIDs: string[], groupUserIDs: string[], externalGroupIDs: string[], successCallback: (retData: ISecurityGroupDetail) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Create`,
            { entitlementGroup: entitlementGroup, permissionIDs: permissionIDs, groupUserIDs: groupUserIDs, externalGroupIDs: externalGroupIDs},
            (data: ISecurityGroupDetail) => {
                successCallback(data);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },

    update: function (entitlementGroup: ISecurityGroup, permissionIDs: any, groupUserIDs: any, externalGroupIDs: any, successCallback: (retData: ISecurityGroupDetail) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Update`,
            { entitlementGroup: entitlementGroup, permissionIDs: permissionIDs, groupUserIDs: groupUserIDs, externalGroupIDs: externalGroupIDs},
            (data: ISecurityGroupDetail) => {
                successCallback(data);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },

    delete: function (entitlementGroup: ISecurityGroup, successCallback: () => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Delete`,
            { ID: entitlementGroup.ID, VersionToken: entitlementGroup.VersionToken},
            (data: ISecurityGroupDetail) => {
                successCallback();
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },

    searchGroup: function (hint: string, successCallback: (data: IExternalGroup[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/QueryDirectory`,
            { nameHint: hint },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getSettings: function (successCallback: (retData: IEntitlementSettings) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/Settings`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    }
};

export default EntitlementServices;
